var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"featureMarquee-item",attrs:{"href":""}},[_c('img',{staticStyle:{"margin-left":"0","margin-top":"0"},style:(_vm.wd),attrs:{"src":_vm.imgUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }